import Layout from '@/page/layout'

const _import = require('../_import')

const scope = 'pay'

export default {
  path: '/pay',
  name: 'pay',
  component: Layout,
  redirect: '/index',
  meta: { title: '账单管理', icon: '' },
  children: [
    {
      path: 'receivables',
      name: 'receivables',
      component: _import(`${scope}/Receivables`),
      meta: { title: '应收账单', icon: '' },
    },
    {
      path: 'bills',
      name: 'bills',
      component: _import(`${scope}/Bills`),
      meta: { title: '应付账单', icon: '' },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/modules/pay.js